import { Combobox } from "@altimateai/lego";
import type { ComboboxOption } from "@altimateai/lego";

interface Props {
  options: ComboboxOption[];
  value: string[];
  onChange: (values: string[]) => void;
}

// Multi-select event-type filter for the (non-DataTable) Auto Tune
// history timeline. Mirrors the warehouse history Combobox: selections
// commit on "Apply", and an empty selection means all event types.
const AutoTuneHistoryEventTypeFilter = ({ options, value, onChange }: Props) => (
  <Combobox
    options={options}
    value={value}
    onChange={onChange}
    multiSelect
    showApplyButton
    header="Event types"
    placeholder="All events"
    buttonProps={{ size: "sm", "aria-label": "Event types", className: "!al-w-56" }}
  />
);

export default AutoTuneHistoryEventTypeFilter;
